import styled from "@emotion/styled";

export const RightSidebarWrapper = styled.div`
  border-left: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  height: inherit;
  overflow-y: inherit;
  position: relative;
  width: inherit;
`;
